import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { Observable, combineLatest, of } from "rxjs";
import { switchMap, take } from "rxjs/operators";
import {
  SessionStorageKey,
  SessionStorageState,
  SsoAccountCheckoutState,
  SsoAccountFacade,
  IdentityVerificationAction,
  SsoAccountData,
  PendingAgreementType,
} from "common";

@Injectable({
  providedIn: "root",
})
export class CheckoutStateDashboardGuard implements CanActivate {
  constructor(
    private router: Router,
    private ssoAccountFacade: SsoAccountFacade
  ) { }

  canActivate(): Observable<boolean> | boolean {
    const hasIdVerseCompletedCallback: boolean = SessionStorageState.get(SessionStorageKey.IdVerseCompletedCallback) === true;

    if (!hasIdVerseCompletedCallback && SessionStorageState.get(SessionStorageKey.AccountSetupViewed)) {
      return true;
    }

    return combineLatest([
      this.ssoAccountFacade.getSsoAccountCheckoutState$(),
      this.ssoAccountFacade.getCurrentSsoAccount$()])
    .pipe(
      take(1),
      switchMap(([checkoutState, current]) => this.validate(checkoutState, current))
    );
  }

  validate(
    checkoutState: SsoAccountCheckoutState,
    current: SsoAccountData,
  ): Observable<boolean> {
    if (checkoutState.identityVerificationAction !== IdentityVerificationAction.Skip) {
      if (current.nextAgreementToSign?.type === PendingAgreementType.Loan) {
        this.router.navigate([`account/${current.nextAgreementToSign.id}/setup`]);
        return of(false);
      } else if (current.nextAgreementToSign?.type === PendingAgreementType.Application || current.pendingApplications?.length > 0) {
        this.router.navigate([`account/setup`]);
        return of(false);
      }

      if (current.loans?.length > 0) {
        this.router.navigate([`account/${current.loans[0].loanId}/setup`]);
        return of(false);
      }
    }
    SessionStorageState.remove(SessionStorageKey.IdVerseCompletedCallback);
    return of(true);
  }
}
